import { render, staticRenderFns } from "./GenericSettingCrud.vue?vue&type=template&id=39a259f2&"
import script from "./GenericSettingCrud.vue?vue&type=script&lang=js&"
export * from "./GenericSettingCrud.vue?vue&type=script&lang=js&"
import style0 from "./GenericSettingCrud.vue?vue&type=style&index=0&id=39a259f2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports